<template>
  <div>
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <vs-row>
            <h4>Guest event log</h4>
            <vs-chip class="ml-2">{{ eventLog.length }}</vs-chip>
          </vs-row>
        </div>
      </div>

      <vs-row v-if="isLoading" class="justify-center">
        <Loading />
      </vs-row>
      <vs-row v-else>
        <ul class="vx-timeline">
          <li v-for="(log, idx) in eventLog" :key="idx">
            <div class="timeline-icon" :class="`bg-primary`">
              <feather-icon icon="ChevronRightIcon" svgClasses="text-white w-5 h-5" />
            </div>
            <div class="timeline-info">
              <p class="font-semibold">{{ log.displayText }}</p>

              <p class="text-sm" v-if="log.displayDescription">{{ log.displayDescription }}</p>
              <p class="text-sm mt-2" v-if="log.entityName || log.entityId">
                {{ log.entityType }}:
                <code>
                  {{ log.entityName }} <small v-if="log.entityId">({{ log.entityId }})</small>
                </code>
              </p>
              <p class="text-sm mt-2" v-if="log.automationId">
                From automation:
                <code
                  >{{ log.automationName }} <small>({{ log.automationId }})</small></code
                >
              </p>
              <p v-if="log.consentedDocumentIds && log.consentedDocumentIds.length > 0" class="text-sm mt-2">
                Consented legal documents: <code>{{ log.consentedDocumentIds.join(", ") }}</code>
              </p>
              <p class="text-sm mt-2">
                State of permissions: <code>{{ log.currentStateOfPermissions.join(", ") }}</code>
              </p>


              
            </div>
            <small class="text-grey activity-e-time"> {{ log.timestamp | formatDate }} · {{ log.type }} · {{ log.eventId }}</small>
          </li>
        </ul>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import { ClientSideRowModelSteps } from "ag-grid-community";

export default {
  components: {},
  props: {
    userProfile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      eventLog: []
    };
  },
  computed: {
    ...mapGetters({
      activeCountryId: "venues/activeCountryId"
    })
  },
  methods: {
    logItemColor(item) {
      switch (item.priority) {
        case "Warning":
          return "success";
        case "Error":
          return "danger";
        default:
          return "primary";
      }
    },

    logItemIcon(item) {
      switch (item.priority) {
        case "Warning":
          return "AlertTriangleIcon";
        case "Error":
          return "AlertTriangleIcon";
        default:
          return "ChevronRightIcon";
      }
    }
  },
  async created() {
    this.profileId = this.$route.params.id;
    this.isLoading = true;

    const eventLogResult = await this.$store.dispatch("userProfiles/getUserProfileLog", {
      country: this.activeCountryId,
      userId: this.profileId
    });
    console.log("Event log result", eventLogResult);
    this.eventLog = eventLogResult.eventLog;

    this.isLoading = false;
  }
};
</script>


<style lang="scss" scoped>
.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>